package com.havn.app.core.platform

enum class HavnSubscriptionDisclosurePlatform {
    Ios,
    Android,
    Web
}

expect fun havnIsTabletDevice(): Boolean

expect fun havnShouldAvoidFloatingNumericKeyboard(): Boolean

expect fun havnAppVersionName(): String

expect fun havnSubscriptionDisclosurePlatform(): HavnSubscriptionDisclosurePlatform
